
export const getUpgradePrice = (name, boosted) => {
  if (boosted) {
    const priceArray = [0, 12.99, 10.99, 8.99, 6.99, 6.99, 6.99]
    return (priceArray[name.length-1]*10**18).toString()
  }else {
    const priceArray = [0, 10, 8, 6, 4, 4, 4]
    return (priceArray[name.length-1]*10**18).toString()
  }
}